import React from 'react';
import DateTimePicker from 'react-datetime-picker';

const TimestampInput = ({column, value, onChange}) => {
  const localChange = (value) => {
    onChange({[column.name]: value})
  }

  if(!value) {
    value = new Date();
  }else if(Object.prototype.toString.call(value) !== '[object Date]') {
    value = new Date(value);
  }

  return (
    <div className="form-group col-md-6">
      <label htmlFor={column.name}>{column.label}</label>
      {/* <input type="datetime-local" className="form-control" name="Name" 
        id={column.name} 
        placeholder={column.placeholder}
        value={value} 
        onChange={onChange(column.name)}></input> */}
        <div>
          <DateTimePicker
            key={column.name}
            name={column.name} 
            format="y-MM-dd h:mm a"
            onChange={localChange}
            value={value}/>
        </div>
    </div>
  );
};

export default TimestampInput;
